import { ThumbnailInfo } from '@app/core/hooks/api/useApiThumbnailsRange';
import { renderMaybeFn } from '@mi-front/core';
import { Stream, StreamProps, ThumbnailsLoading, ThumbnailsRollV2 } from '@mi-front/ui';
import { useEffect, useState } from 'react';
import { useThumbnailsStreamSegments } from './hooks/useThumbnailsStreamSegments';
import { useTimestampedThumbnails } from './hooks/useTimestampedThumbnails';

interface ThumbnailsStreamV2Props extends StreamProps {
  readonly thumbnails: ThumbnailInfo[];
  readonly thumbnailsLoading: boolean;
}

const THUMB_HEIGHT = 81;

/**
 * Renders a time-aligned thumbnail filmstrip for the logger video preview.
 */
export function ThumbnailsStreamV2({
  thumbnails,
  thumbnailsLoading,
  range,
  ...streamProps
}: ThumbnailsStreamV2Props) {
  const { segments, isLoading: segmentsLoading } = useThumbnailsStreamSegments(range);
  const timestampedThumbnails = useTimestampedThumbnails(thumbnails, segments);
  const isRollLoading = thumbnailsLoading || segmentsLoading;
  const [showLoading, setShowLoading] = useState(true);

  // Keep the placeholder visible while the CSS sprites finish rendering.
  useEffect(() => {
    if (!isRollLoading) {
      setTimeout(() => {
        setShowLoading(false);
      }, 3000);
    }
  }, [isRollLoading]);

  return (
    <Stream
      {...streamProps}
      range={range}
      compressed
      htmlBehindSvg
      renderHtml={() => showLoading && <ThumbnailsLoading />}
      renderSvg={() => (
        <>
          {!isRollLoading && (
            <ThumbnailsRollV2 thumbHeight={THUMB_HEIGHT} thumbnails={timestampedThumbnails} />
          )}
          {renderMaybeFn(streamProps.renderSvg)}
        </>
      )}
    />
  );
}
